module.exports = __webpack_public_path__ + "img/barcode.c4d1f82c.svg";